<template lang="pug">
div
	#bg
		.hero-text
			h1 Novas Ignaras Gambiarras
			md-button.md-accent.md-raised.md-primary(to="/") Apertar
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
	name: 'Home',
	components: {
		HelloWorld
	}
}
</script>

<style lang="scss" scoped>

	#bg {
	background: url('../assets/images/vintage-test-two.jpeg');
	position: fixed; 
	top: -50%; 
	left: -50%; 
	width: 200%; 
	height: 200%;
	background-size: cover;
	background-color: #848482;
	background-blend-mode: multiply;
	}

	#bg img {
	position: absolute; 
	top: 0; 
	left: 0; 
	right: 0; 
	bottom: 0; 
	margin: auto; 
	min-width: 50%;
	min-height: 50%;
	}

	.hero-image {
		background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url("../assets/images/linotpographer.jpg");
		height: 100%;
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		position: relative;
	}


	.hero-text {
		text-align: center;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		color: white;
	}

  .md-card {
	width: 320px;
	margin: 4px;
	display: inline-block;
	vertical-align: top;
	padding: 25px;
	text-align: left;
  }

.md-subhead {
	font-size: 18px !important;
	margin-top: 7px !important;
}

</style>